import useSWR, { unstable_serialize } from "swr";
import { useState } from "react";
import { pushApi } from "./api";

export const useApi = ({
  url,
  params,
  lazy = false,
  method = "get",
  body,
  fetcher,
  fetchOptions,
}) => {
  const SWRKey = unstable_serialize([url, params, body]);
  const { data, error, isValidating, mutate } = useSWR(
    lazy ? null : SWRKey,
    fetcher
      ? () => fetcher()
      : () => pushApi.request({ url, params, body, method }),
    fetchOptions
  );

  return {
    data,
    error,
    isValidating,
    mutate,
    isLoading: !lazy && !data && !error,
    isEmpty: !data || (Array.isArray(data) && data.length === 0),
  };
};

export const WithUseApi = (WrappedComponent) => {
  const [swrParams, setSWRParams] = useState();
  const response = useApi({
    lazy: !swrParams,
    ...swrParams,
  });
  return;
};
